import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog as MUIDailog } from '@material-ui/core';
import withSizes from 'react-sizes';

import { dialogSelectors } from '@store/ducks';
import { GetOTP, VerifyAadharOTP, Tnc } from '@components/KYC/Aadhar';
import Sheet from 'deltoid/core/Blocks/Sheet';

const Dialog = ({
  type,
  open,
  onClose: onCloseProp,
  isMobile,
}) => {

  const getChild = type => {
    switch(type) {
      case 'aadhar-get-otp':
        return <GetOTP/>
      case 'aadhar-verify-otp':
        return <VerifyAadharOTP/>;
      case 'aadhar-tnc':
        return <Tnc/>
      default:
        return null;
    }
  }

  const handleClose = () => onCloseProp();

  const maxWidth = (type) => {
    switch(type) {
      case 'aadhar-tnc':
        return 'md';
      default:
        return 'xs';
    }
  }

  return (
    <>
      {
        getChild(type) ? (
          !isMobile ? (
            <MUIDailog
            open={open}
            onClose={handleClose}
            maxWidth={maxWidth(type)}
            // fullWidth={['kyc-address'].includes(type)}
            >
            {getChild(type)}
            </MUIDailog>
          ) : (
            <Sheet className='bg-white sheet-b-radius' open={open} bottom onOverlayClick={handleClose}>
              {getChild(type)}
            </Sheet>
          )
        ) : <></>
      }
    </>
  )
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});
const ResponsiveDialog = withSizes(mapSizesToProps)(Dialog);

const mapStateToProps = (state) => {
  return {
    open: dialogSelectors.open(state),
    type: dialogSelectors.type(state),
  };
};

export default connect(mapStateToProps)(ResponsiveDialog);
